module.exports = __webpack_public_path__ + "static/dashboard_en_bg@2x-6a69137ead7a093e634cfaf13dc2828e.png";